import Chronicpain from "../assets/images/blog/pain-body-muscles-stiff-problem-suffer.webp"
import digitalSlump from "../assets/images/blog/The-Digital-Slump-How-Your-Remote-Work-Setup-is-Aging-Your-Spine.webp"
import ChiropracticAdjust from "../assets/images/blog/10-Ways-Regular-Chiropractic-Adjustments-Can-Level-Up-Your-Training-Routine.webp"
import GuideCupping from "../assets/images/blog/The-Beginners-Guide-to-Cupping-6-Things-to-Know-Before-Your-Appointment.webp"
import CuppingTherapy from "../assets/images/blog/How-Cupping-Therapy-Can-Enhance-Your-Physical-Therapy-Results.webp"
import fivePowerfulAcupuncture from "../assets/images/blog/5-Powerful-Ways-Acupuncture-Can-Enhance-the-Benefits-of-Chiropractic-Care.webp"
import CareBoostAthletic from "../assets/images/blog/How-Does-Chiropractic-Care-Boost-Athletic-Performance.webp"
import WhatisSubluxation from "../assets/images/blog/What-is-Subluxation-A-Guide-to-Spinal-Misalignment.webp"
import PostureShortCircuiting from "../assets/images/blog/Is-Your-Posture-Short-Circuiting-Your-Nerves-Ergonomic-and-Chiropractic-Tips.webp"
import SevenHiddenSigns from "../assets/images/blog/7-Hidden-Signs-of-a-Spinal-Subluxation.webp" 
import HowToRelieveTension from "../assets/images/blog/How-to-Relieve-a-Tension-Headache-Without-Medication.webp"
import WhatPhysicalFixes from "../assets/images/blog/What-Physical-Fixes-Can-You-Try-for-Immediate-Relief.webp"
import PreventTension from "../assets/images/blog/How-Do-You-Prevent-Tension-Headaches-Before-They-Start.webp"
import CausesSciatica from "../assets/images/blog/What-Causes-Sciatica.webp"
import CausesSciaticaChiroCare from "../assets/images/blog/What-Causes-Sciatica-and-How-Chiropractic-Care-Can-Help.webp"
import FirstVisitChiro from "../assets/images/blog/What-to-Expect-During-Your-First-Chiropractic-Visit.webp"

export const blogs = [
  {
    title: "How to Relieve a Tension Headache Without Medication",
    date: "July 6, 2026",
    excerpt:
      "A tension headache feels like a tight band squeezing your skull, and it can completely ruin your day.",
    link: "/blog/relieve-tension-headache-without-medication/",
    image: HowToRelieveTension,
  },
  {
    title: "What Causes Sciatica, and How Chiropractic Care Can Help",
    date: "July 13, 2026",
    excerpt:
      "A sharp, electric shock shoots from your lower back down through your leg, turning simple movements like sitting or standing into a painful struggle.",
    link: "/blog/what-causes-sciatica-chiropractic-care/",
    image: CausesSciaticaChiroCare,
  },
  {
    title: "Why Old Aches Return: How Chiropractic Adjustments Help With Chronic Pain",
    date: "May 9, 2026",
    excerpt:
      "Many people live with the quiet memory of an old sports injury or a minor car accident. You might feel fine for years until a simple movement, like reaching for a shelf, triggers a familiar sharp pain.",
    link: "/blog/chiropractic-for-chronic-pain/",
    image: Chronicpain,
  },
  {
    title: "The Digital Slump: How Your Remote Work Setup is Aging Your Spine",
    date: "April 6, 2026",
    excerpt:
      "Remote work offers a level of freedom that traditional office environments rarely provide.",
    link: "/blog/digital-slump-aging-your-spine/",
    image: digitalSlump,
  },
  {
    title: "10 Ways Regular Chiropractic Adjustments Can Level Up Your Training Routine",
    date: "February 2, 2026",
    excerpt:
      "You have the diet, the program, and the gear, but you might be overlooking your nervous system.",
    link: "/blog/chiropractic-adjustments-training-routine",
    image: ChiropracticAdjust,
  },
  {
    title: "The Beginner’s Guide to Cupping: 6 Things to Know Before Your Appointment",
    date: "February 9, 2026",
    excerpt:
      "You have likely seen the circular purple marks on the backs of Olympic swimmers or professional athletes.",
    link: "/blog/beginners-guide-to-cupping/",
    image: GuideCupping,
  },
  {
    title: "How Cupping Therapy Can Enhance Your Physical Therapy Results",
    date: "March 2, 2026",
    excerpt:
      "Physical therapy provides targeted exercises, manual therapy, and vital education.",
    link: "/blog/cupping-therapy-physical-therapy-results/",
    image: CuppingTherapy,
  },
  {
    title: "5 Powerful Ways Acupuncture Can Enhance the Benefits of Chiropractic Care",
    date: "April 13, 2026",
    excerpt:
      "Chiropractic care and acupuncture are two respected natural pain management therapies.",
    link: "/blog/5-ways-acupuncture-enhances-chiropractic-care/",
    image: fivePowerfulAcupuncture,
  },
  {
    title: "How Does Chiropractic Care Boost Athletic Performance?",
    date: "May 15, 2026",
    excerpt:
      "Elite athletes often use chiropractic care for performance, recovery, and longevity.",
    link: "/blog/chiropractic-care-boost-athletic-performance/",
    image: CareBoostAthletic,
  },
  {
    title: "What is Subluxation? A Guide to Spinal Misalignment",
    date: "June 1, 2026",
    excerpt:
      "A guide to spinal misalignment, discomfort, and chiropractic care.",
    link: "/blog/what-is-subluxation/",
    image: WhatisSubluxation,
  },
  {
    title: "Is Your Posture Short-Circuiting Your Nerves? Ergonomic and Chiropractic Tips",
    date: "May 4, 2026",
    excerpt:
      "Office posture can lead to tingling, neck pain, and nerve irritation.",
    link: "/blog/posture-short-circuiting-nerves/",
    image: PostureShortCircuiting,
  },
  {
    title: "7 Hidden Signs of a Spinal Subluxation (And How to Fix It)",
    date: "June 1, 2026",
    excerpt:
      "Many people wake up feeling stiff or struggle with a nagging ache that lingers throughout the day.",
    link: "/blog/hidden-signs-of-spinal-subluxation/",
    image: SevenHiddenSigns,
  }
]
